import React from 'react';

// Africa continent silhouette — matches the watermark in the Varahi template image
const AfricaMap = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 400 520"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M160,10 L200,8 L240,15 L270,25 L290,45 L300,70 L310,95 
         L305,120 L315,140 L320,165 L315,185 L325,205 L330,230 
         L325,255 L330,275 L325,300 L315,320 L310,340 L320,360 
         L318,380 L305,400 L290,420 L270,440 L250,458 L230,470 
         L210,480 L195,490 L180,485 L165,475 L150,460 L135,445 
         L118,428 L100,408 L88,385 L82,360 L85,335 L78,310 
         L72,285 L75,260 L70,235 L65,210 L60,185 L58,160 
         L62,135 L70,112 L80,90 L90,68 L105,48 L125,30 L145,18 Z"
      fill="#0d3d2a"
      opacity="0.6"
    />
    {/* Madagascar */}
    <ellipse cx="340" cy="320" rx="18" ry="40" fill="#0d3d2a" opacity="0.5" transform="rotate(-15 340 320)" />
  </svg>
);

export default AfricaMap;
